module.exports = __webpack_public_path__ + "static/media/speaker.7687449d.jpeg";